import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';

const SearchStatusDto = t.type(
  {
    id: nullable(t.number),
    name: nullable(t.string),
    color: nullable(t.string),
  },
  'SearchRequest',
);

type SearchStatusDto = t.TypeOf<typeof SearchStatusDto>;
export { SearchStatusDto };
